import { render, staticRenderFns } from "./ShareURLDialog.vue?vue&type=template&id=5a0c3ca7&scoped=true&lang=pug"
import script from "./ShareURLDialog.vue?vue&type=script&lang=js"
export * from "./ShareURLDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareURLDialog.vue?vue&type=style&index=0&id=5a0c3ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c3ca7",
  null
  
)

export default component.exports